<template>
    <AdminNextIframe
        path="/pagebuilder"
        :query="{ clientId: $route.params.id }" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientPagebuilderManager',
    components: { AdminNextIframe }
}
</script>
